import React, {useState, useRef} from 'react';
import {Row, Col} from 'react-bootstrap';
import ListNav from '../../components/tabsNav/TabsNav';
import {t} from 'react-switch-lang';
import First from './components/FirstTable';
import SecondTable from './components/SecondTable';
import ThirdTable from './components/ThirdTable';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import Dropdown from '../../components/droppdown/dropdown';
import roles from '../../utils/roles';
import '../Risks/test.scss';
const RiskConsiderationsEntered = () => {
  const [activeTab, setActiveTab] = useState('potential-risks');
  const user = useUserContext();
  const departments = useDepartmentContext();
  const userAuthorities = useUserContext().authorities;
  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const userResponsible = userAuthorities.some((r) =>
    r.includes(roles.role_responsible_user)
  );
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );

  return (
    <>
      <div className="mx-5">
        <Row>
          <Col xs="12" lg="12" className="mt-4">
          {userInCharge || userSuperAdmin ? (
              <Dropdown
                buttonClass="float-right all-risks primary-btn"
                trigger={t('common.addRisk')}
                riskConsideration={'margin-top'}
                children={
                  <>
                    <li
                      onClick={() => {
                        window.location = `/potential-risk/add`;
                      }}
                    >
                      {t('navbar.potentialRisk')}
                    </li>
                    <li
                      onClick={() => {
                        window.location = `/incurred-risk/add`;
                      }}
                    >
                      {t('navbar.resultingAdverseEvent')}
                    </li>
                    {departments.some((r) => r.id === 9) || userSuperAdmin ?  (
                      <li
                        onClick={() => {
                          window.location = `/court-risk/add`;
                        }}
                      >
                        {t('navbar.litigation')}
                      </li>
                    ) : ''}
                  </>
                }
              ></Dropdown>
            ) : ''}

            <ListNav
              items={[
                {name: t('tabsNav.potential-risks'), target: 'potential-risks'},
                {name: t('tabsNav.occured'), target: 'occured'},
                ...(departments.some((r) => r.id === 9) || userRiskSector || userSuperAdmin
                ? [{name: t('tabsNav.litigation'), target: 'litigation'}]
                : []),
              ]}
              textProperty="name"
              itemValue="target"
              selectedItem={activeTab}
              onItemSelect={setActiveTab}
              classes="tabs-nav ml-0 pl-0"
            />
          </Col>
        </Row>
        {activeTab === 'potential-risks' && (
          <First
            activeTab={activeTab}
            user={user}
            departments={departments}
            roles={{
              userSuperAdmin: userSuperAdmin,
              userRiskSector: userRiskSector,
              userInCharge: userInCharge,
              userResponsible: userResponsible,
            }}
          />
        )}
        {activeTab === 'occured' && (
          <SecondTable
            activeTab={activeTab}
            user={user}
            departments={departments}
            roles={{
              userSuperAdmin: userSuperAdmin,
              userRiskSector: userRiskSector,
              userInCharge: userInCharge,
              userResponsible: userResponsible,
            }}
          />
        )}
        {activeTab === 'litigation' && (
          <ThirdTable
            activeTab={activeTab}
            user={user}
            departments={departments}
            roles={{
              userSuperAdmin: userSuperAdmin,
              userRiskSector: userRiskSector,
              userInCharge: userInCharge,
              userResponsible: userResponsible,
            }}
          />
        )}
      </div>
    </>
  );
};

export default RiskConsiderationsEntered;
